import type { AiBusinessCenterModule } from '../types'

/** 合同管理独立应用配置。 */
export const contractModule: AiBusinessCenterModule = {
  key: 'contract',
  label: '合同管理',
  desc: '合同台账/模板/变更终止/履约/收付款/借阅/续签/风险预警/电子签章',
  path: '/contract',
  homePath: '/contract/contract',
  icon: 'ep:document-checked',
  color: '#8b5cf6'
}
